import { FormattedDate, FormattedMessage } from "react-intl";

import styled from "styled-components";

import { Empty, List, Skeleton, Tag, Typography } from "antd";

import { CmtSectionCard } from "@app/components/common/CmtSectionCard.tsx";
import { useUserMissions } from "@app/services/hook/useUserMissions.tsx";
import { colors } from "@app/theme.ts";

const StyledClient = styled.div`
  font-weight: 700;
`;

interface CmtUserMissionsProps {
  email: string;
}

export const CmtUserMissions = ({ email }: CmtUserMissionsProps) => {
  const { missions, isLoading } = useUserMissions(email);

  return (
    <CmtSectionCard
      title={<FormattedMessage id="app.missions" defaultMessage="Missions" />}
      extra={isLoading ? undefined : missions.length}
    >
      {isLoading && <Skeleton active paragraph={{ rows: 2 }} />}
      {!isLoading && missions.length === 0 && (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <FormattedMessage
              id="collaborator.missions.empty"
              defaultMessage="No mission yet"
            />
          }
        />
      )}
      {!isLoading && missions.length > 0 && (
        <List
          itemLayout="horizontal"
          dataSource={missions}
          rowKey="id"
          renderItem={(mission) => (
            <List.Item
              extra={
                mission.missionEnded ? (
                  <Tag>
                    <FormattedMessage
                      id="table.mission_ended"
                      defaultMessage="Finished"
                    />
                  </Tag>
                ) : (
                  <Tag color="green">
                    <FormattedMessage
                      id="collaborator.missions.ongoing"
                      defaultMessage="Ongoing"
                    />
                  </Tag>
                )
              }
            >
              <div>
                <StyledClient>{mission.clientName}</StyledClient>
                <div>{mission.name}</div>
                <Typography.Text
                  type="secondary"
                  style={{ fontSize: "0.85rem" }}
                >
                  <FormattedDate
                    value={new Date(mission.startDate)}
                    dateStyle="medium"
                  />
                  {" → "}
                  {mission.endDate ? (
                    <FormattedDate
                      value={new Date(mission.endDate)}
                      dateStyle="medium"
                    />
                  ) : (
                    "…"
                  )}
                  {mission.prolongations.length > 0 && (
                    <span style={{ color: colors.pink, marginLeft: "0.5rem" }}>
                      <FormattedMessage
                        id="collaborator.missions.prolongations"
                        defaultMessage="{count, plural, one {# extension} other {# extensions}}"
                        values={{ count: mission.prolongations.length }}
                      />
                    </span>
                  )}
                </Typography.Text>
              </div>
            </List.Item>
          )}
        />
      )}
    </CmtSectionCard>
  );
};
